<div class="box" [class.white]="white">
  <mat-icon class="check-icon">check</mat-icon>
  <span class="text text-trim">SEPA</span>
</div>
